<script setup lang="ts">
import { computed } from 'vue'

import {
  ScalarIcon,
  ScalarListbox,
  type ScalarListboxOption,
} from '@scalar/components'
import { normalizeRefVersion } from '@scalar-org/helpers/normalize'

const { versions, modelValue } = defineProps<{
  versions: string[]
  modelValue?: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

// Show the selector if there are multiple options
const showSelector = computed(() => versions && versions?.length > 1)

const listboxOptions = computed(
  () =>
    versions?.map((version) => ({
      id: version,
      label: normalizeRefVersion(version, version).label,
    })) || [],
)

const selectedOption = computed({
  get: () => listboxOptions.value.find(({ id }) => id === modelValue),
  set: (opt: ScalarListboxOption) => emit('update:modelValue', opt.id),
})
</script>

<template>
  <template v-if="showSelector">
    <div class="document-selector">
      <ScalarListbox
        v-model="selectedOption"
        :options="listboxOptions"
        resize>
        <div
          class="group/dropdown-label py-1.75 pl-1.75 text-c-2 hover:bg-b-2 flex w-full cursor-pointer items-center rounded border pr-1.5"
          tabindex="0">
          <ScalarIcon
            class="mr-1.25 min-w-4"
            icon="Versions"
            size="sm"
            thickness="2" />
          <span
            class="text-c-1 overflow-hidden text-ellipsis text-sm font-medium">
            {{ selectedOption?.label || 'Select API' }}
          </span>
          <ScalarIcon
            class="group-hover/dropdown-label:text-c-1 ml-auto mr-2"
            icon="ChevronDown"
            size="sm"
            thickness="2" />
        </div>
      </ScalarListbox>
    </div>
  </template>
</template>

<style scoped>
.document-selector {
  margin-bottom: 10px;
}
</style>
